import React from 'react';
import '../styles/skills.scss';
// Mantenha seus imports de ícones aqui...
import { FaHtml5, FaSass, FaReact, FaAngular, FaPhp, FaFigma, FaLinux, FaWordpress, FaLaravel, FaGulp } from 'react-icons/fa';
import { SiJavascript, SiCss3, SiTypescript, SiFirebase, SiGit, SiBootstrap, SiMaterialdesign, SiMaterialui } from 'react-icons/si';

const skillsData = [
  // ... seus dados (mantenha igual) ...
  {id: 1, title: 'HTML', icon: <FaHtml5 />},
  {id: 2, title: 'CSS', icon: <SiCss3 />},
  {id: 3, title: 'SASS', icon: <FaSass />},
  {id: 4, title: 'Bootstrap', icon: <SiBootstrap />},
  {id: 5, title: 'React', icon: <FaReact />},
  {id: 5, title: 'Angular', icon: <FaAngular />},
  {id: 6, title: 'JavaScript', icon: <SiJavascript />},
  {id: 7, title: 'TypeScript', icon: <SiTypescript />},
  {id: 8, title: 'Git', icon: <SiGit />},
  {id: 9, title: 'Figma', icon: <FaFigma />},
  {id: 10, title: 'Material Design', icon: <SiMaterialdesign />},
  {id: 11, title: 'Material UI', icon: <SiMaterialui />},
  {id: 12, title: 'Linux', icon: <FaLinux />},
  {id: 13, title: 'Firebase', icon: <SiFirebase />},
  {id: 14, title: 'WordPress', icon: <FaWordpress />},
  {id: 15, title: 'PHP', icon: <FaPhp />},
  {id: 16, title: 'Laravel', icon: <FaLaravel />},
  {id: 17, title: 'Gulp', icon: <FaGulp />},
];

export function Skills() {
    const half = Math.ceil(skillsData.length / 2);
    const firstRow = skillsData.slice(0, half);
    const secondRow = skillsData.slice(half);

    return (
      <div id="skills">
        <div className="skillsHeader">
          <h2>Skills</h2>
        </div>
        
        <div className="skillsContainer">
          <div className="skillsTrack">
            {firstRow.map((skill) => (
               <div className="skill--box" key={skill.id}>
                 <i className='skillsImage'>{skill.icon} </i>
                 <h3>{skill.title}</h3>
               </div>
            ))}
            {firstRow.map((skill) => (
               <div className="skill--box" key={`dup-1-${skill.id}`}>
                 <i className='skillsImage'>{skill.icon} </i>
                 <h3>{skill.title}</h3>
               </div>
            ))}
          </div>
        </div>

        <div className="skillsContainer reverse"> 
          <div className="skillsTrack">
            {secondRow.map((skill) => (
               <div className="skill--box" key={skill.id}>
                 <i className='skillsImage'>{skill.icon} </i>
                 <h3>{skill.title}</h3>
               </div>
            ))}
            {secondRow.map((skill) => (
               <div className="skill--box" key={`dup-2-${skill.id}`}>
                 <i className='skillsImage'>{skill.icon} </i>
                 <h3>{skill.title}</h3>
               </div>
            ))}
          </div>
        </div>
      </div>
    )
}